module.exports = __webpack_public_path__ + "img/Ident-Process-2.e89a31bc.png";